// ==========================================================
// YYS B2B site — reveal animations + counters + tilt
// ==========================================================

const reveals = document.querySelectorAll(".reveal");
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
      }
    });
  },
  { threshold: 0.12 }
);
reveals.forEach((node) => observer.observe(node));

document
  .querySelectorAll(".family-panel, .resource-link, .download-card, .case-card, .module-card")
  .forEach((node) => {
    node.addEventListener("pointermove", (event) => {
      const rect = node.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * 3;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * -3;
      node.style.transform = `translateY(-4px) rotateX(${y}deg) rotateY(${x}deg)`;
    });
    node.addEventListener("pointerleave", () => {
      node.style.transform = "";
    });
  });

// ----- animated counter (stats from 0 to target on scroll) -----
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function animateCounter(el) {
  const target = parseFloat(el.dataset.target || el.textContent.replace(/[^\d.]/g, ""));
  const duration = parseInt(el.dataset.duration || "1400", 10);
  const decimals = parseInt(el.dataset.decimals || "0", 10);
  const prefix = el.dataset.prefix || "";
  const suffix = el.dataset.suffix || "";
  if (isNaN(target)) return;

  if (reduceMotion) {
    el.textContent = prefix + target.toFixed(decimals) + suffix;
    return;
  }

  const start = performance.now();
  function tick(now) {
    const t = Math.min(1, (now - start) / duration);
    const eased = 1 - Math.pow(1 - t, 3);
    const current = target * eased;
    el.textContent = prefix + current.toFixed(decimals) + suffix;
    if (t < 1) requestAnimationFrame(tick);
    else el.textContent = prefix + target.toFixed(decimals) + suffix;
  }
  requestAnimationFrame(tick);
}

const counterObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;
        if (!el.dataset.counted) {
          el.dataset.counted = "1";
          animateCounter(el);
        }
        counterObserver.unobserve(el);
      }
    });
  },
  { threshold: 0.5 }
);
document.querySelectorAll(".counter").forEach((el) => counterObserver.observe(el));
